import TextBlock from "../typeComponents/TextBlock";
import MainHeading from "../typeComponents/MainHeading";
import Paragraph from "../typeComponents/Paragraph";
import { Link as RouterLink } from "react-router-dom";
import CureLogo from "../images/CURE_logo_clean_vector.svg";
import { Box, Button, Typography } from "@mui/material";

// TODO: add date, time, and location for each of the events */}
// Also, not sure if we want images? THey don't pop a ton currently tbh */}

const Home = () => {
  return (
    <>
      <TextBlock>
        <MainHeading>Welcome to CURE!</MainHeading>
        {/* Box is to give MUI styling control to img - there is so standard MUI Image component */}
        <Box sx={{ width: { xs: "45vw", md: "24vw" }, padding: "10px" }}>
          <img
            height={"100%"}
            width={"100%"}
            src={CureLogo}
            alt="CURE Montreal Logo"
          />
        </Box>
        <Box
          sx={{
            minWidth: "55vw",
            border: 5,
            borderStyle: "dashed",
            // borderColor: "primary.main",
            padding: 2.5,
            marginBottom: 2,
          }}
        >
          <MainHeading>CURE is hiring!</MainHeading>
          <Typography>
            We're hiring a student community outreach assistant for our current
            project, Estran, a web app and community push to make high-quality
            trans healthcare more accessible!
          </Typography>
          <br></br>
          <Typography>
            <Button
              variant="contained"
              sx={{ color: "primary.contrastText" }}
              component={RouterLink}
              to={"Hiring"}
            >
              Click here
            </Button>{" "}
            to learn more!
          </Typography>
        </Box>
        <Paragraph>
          CURE promotes community-driven social justice research. We foster
          collaborations between students and grassroots community groups
          working for social change. By facilitating meaningful exchanges
          between students and activists, CURE strives to redefine the terms of
          research and break the boundary between researchers and communities.
        </Paragraph>
      </TextBlock>
      {/* <EventsPaper /> */}
      <TextBlock>
        <Paragraph>
          For any general inquiries, or if you're interested in getting
          involved, anyone is encouraged to contact us at{" "}
          <a href="mailto:curemontreal@gmail.com">curemontreal@gmail.com</a>!
        </Paragraph>
        <Button
          variant="contained"
          sx={{ color: "primary.contrastText", marginBottom: 2 }}
          component={RouterLink}
          to={"join-our-board"}
        >
          Join Our Board!
        </Button>
      </TextBlock>
    </>
  );
};
export default Home;
